import { P2GBox } from '@parcel2go/peacock-legacy-core/dist/box';
import { P2GGrid } from '@parcel2go/peacock-legacy-core/dist/grid';
import { P2GLink } from '@parcel2go/peacock-legacy-core/dist/link';
import { P2GLinkGroup } from '@parcel2go/peacock-legacy-core/dist/linkgroup';
import { P2GText } from '@parcel2go/peacock-legacy-core/dist/typography';
import React from 'react';
import { Account, ActionType, Integration, IntegrationStatus } from '../services/api/types';
import { IP2GTheme } from '@parcel2go/peacock-legacy-themes/dist/types';
import useTheme from '@material-ui/core/styles/useTheme';

interface props {
  integration: Integration;
  onClose: (accountId: string) => void;
  account: Account;
  editAccount: (action: ActionType) => void;
}

export default function IntegrationAccount(props: props) {
  const theme = useTheme<IP2GTheme>();

  const GetColourByStatus = (status: IntegrationStatus) => {
    switch (status) {
      case 'Active':
      case 'Submitted':
        return theme.palette.success.main;

      case 'ConfigurationRequired':
      case 'ConsentRequired':
      case 'Pending':
      case 'PendingDeletion':
        return theme.palette.warning.main;

      case 'Expired':
      case 'Inactive':
      case 'Rejected':
      case 'Unknown':
        return theme.palette.error.main;

      default:
        return theme.palette.success.main;
    }
  };

  const GetDescriptionByStatus = (status: IntegrationStatus) => {
    switch (status) {
      case 'ConfigurationRequired':
      case 'ConsentRequired':
        return 'Action Required';

      case 'PendingDeletion':
        return 'Delete Pending';

      default:
        return status;
    }
  };

  return (
    <P2GGrid container alignContent="center" alignItems="center" wrap="nowrap">
      <P2GGrid item flexShrink={1}>
        <P2GBox bordered textAlign="center" p={2}>
          <P2GText variant="body2">
            <strong style={{ color: GetColourByStatus(props.account.status) }}>
              {GetDescriptionByStatus(props.account.status)}
            </strong>
          </P2GText>
        </P2GBox>
      </P2GGrid>
      <P2GGrid item flexGrow={1}>
        <P2GBox bordered p={2}>
          <P2GText variant="body2">{props.account.name}</P2GText>
        </P2GBox>
      </P2GGrid>
      <P2GGrid item flexShrink={1}>
        <P2GBox pl={2}>
          <P2GLinkGroup
            links={props.account.actions.map((a) => (
              <P2GLink key={a} onClick={() => props.editAccount(a)}>
                {a}
              </P2GLink>
            ))}
          />
        </P2GBox>
      </P2GGrid>
    </P2GGrid>
  );
}
